/**
 * Given a string of digits (non-digits stripped), returns the auto-formatted
 * display value with a `/` inserted after position 2.
 *
 * ""     → ""
 * "04"   → "04/"
 * "0408" → "04/08"
 */
export function formatDateInput(digits: string): string {
  const d = digits.replace(/\D/g, '').slice(0, 4)
  if (d.length < 2) return d
  if (d.length === 2) return `${d}/`
  return `${d.slice(0, 2)}/${d.slice(2)}`
}

/**
 * Parses a completed "MM/DD" string into a Date at 09:00 local time.
 * Returns the nearest future occurrence:
 * - current year if that date has not yet passed
 * - next year otherwise
 * Returns null for invalid input.
 */
export function parseDateInput(input: string): Date | null {
  const match = input.match(/^(\d{2})\/(\d{2})$/)
  if (!match) return null

  const month = parseInt(match[1], 10) - 1
  const day = parseInt(match[2], 10)

  if (month < 0 || month > 11 || day < 1 || day > 31) return null

  const now = new Date()
  const thisYear = new Date(now.getFullYear(), month, day, 9, 0, 0, 0)

  // Validate the date is real (e.g. not Feb 30)
  if (thisYear.getMonth() !== month) return null

  // Compare date-only (ignore time) so today's date isn't pushed to next year
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const candidateStart = new Date(now.getFullYear(), month, day)
  if (candidateStart >= todayStart) return thisYear
  return new Date(now.getFullYear() + 1, month, day, 9, 0, 0, 0)
}
